module.exports = __webpack_public_path__ + "static/media/cancun.6781aedd.jpg";